// extracted by mini-css-extract-plugin
export default {"buttonContainer":"CustomPlanMenu_buttonContainer__HwFE9","deleteButton":"CustomPlanMenu_deleteButton__OUTnG"};